








/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Emit, InjectReactive, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    computed: {

        _isFormOption() {
            return true;
        },

        cIsSelected() {
            if (Array.isArray(this.selected))
                return this.selected.includes(this.$vnode.key);
                
            return this.$vnode.key === this.selected;
        },

        cClass() {
            let classes = ['form-option'];

            if (this.cIsSelected)
                classes.push('is-selected');

            return classes.join(' ');
        },
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class FormOption extends Vue {
    @InjectReactive('selected') readonly selected!: string

    @Emit()
    select() {
        return this;
    }
}

